import React, {useEffect, useState} from "react";
import {IonIcon, IonItem} from "@ionic/react";
import {alertCircleOutline, calendarClearOutline, chevronDown, chevronUp, informationCircleOutline} from "ionicons/icons";
import RoadTest from "./RoadTest";
import {ApiService} from "../api/ApiService";
import {Trainee} from "../api/model/Trainee";

interface Course {
    enabled: number;
    id: number;
    title: string;
    total_backing_events: number;
    total_days: number;
}

const DailyReport = (props: any) => {
    const now = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)

    const [showBacking, setShowBacking] = useState(false)
    const [showTurning, setShowTurning] = useState(false)
    const [showHabits, setShowHabits] = useState(false)
    const [showCity, setShowCity] = useState(false)
    const [showHighway, setShowHighway] = useState(false)
    const [showTablet, setShowTablet] = useState(false)
    const [showDefense, setShowDefense] = useState(false)
    const [showHOS, setShowHOS] = useState(false)
    const [showBackingCriteria, setShowBackingCriteria] = useState(false)
    const [showTurningCriteria, setShowTurningCriteria] = useState(false)
    const [showHabitsCriteria, setShowHabitsCriteria] = useState(false)
    const [showCityCriteria, setShowCityCriteria] = useState(false)
    const [showHighwayCriteria, setShowHighwayCriteria] = useState(false)
    const [showTabletCriteria, setShowTabletCriteria] = useState(false)
    const [showDefenseCriteria, setShowDefenseCriteria] = useState(false)
    const [showHOSCriteria, setShowHOSCriteria] = useState(false)
    const [backingScore, setBackingScore] = useState(0);
    const [turningScore, setTurningScore] = useState(0);
    const [roadHabitsScore, setRoadHabitsScore] = useState(0);
    const [cityScore, setCityScore] = useState(0);
    const [highwayScore, setHighwayScore] = useState(0);
    const [tabletScore, setTabletScore] = useState(0);
    const [hosScore, setHOSScore] = useState(0);
    const [defensiveScore, setDefensiveScore] = useState(0);
    const [showRoadTest, setShowRoadTest] = useState(false);
    const [courses, setCourses] = useState<Course[]>([]);
    const [reportTimer, setReportTimer] = useState<string>('Not Ready');
    const [activity, setActivity] = useState<string>('');
    const [safety, setSafety] = useState<string>('');
    const [trainingDate] = useState(now.toISOString().split('T')[0]);
    const [hasRoadTest, setHasRoadTest] = useState(true);
    const [course, setCourse] = useState<Course>({
        enabled: 0,
        id: 0,
        title: '',
        total_backing_events: 0,
        total_days: 0
    });
    const [changingCourse, setChangingCourse] = useState(false);
    const [selectedCourseId, setSelectedCourseId] = useState(0);
    const [traineeAccident, setTraineeAccident] = useState('');
    const [traineeReady, setTraineeReady] = useState('');

    useEffect(() => {
        parseTrainee(props.traineeData)
        ApiService.getTrainingCourses('dailyReport').then(it => {
            parseCourses(it);
        });
    }, []);

    const parseTrainee = (traineeObj: Trainee) => {
        getPrompt(traineeObj.currentCourseId, traineeObj.currentCourseDay);
        ApiService.getTrainingReportDayPassed2("dailyReport", {traineeCode: traineeObj.traineeCode}).then(isNewDay => {
            setReportTimer(isNewDay && traineeObj.currentCourseId !== 0 ? 'Ready to Submit' : 'Not Ready');
        });
    }

    const parseCourses = (courseArray: any[]) => {
        let tempArray: Course[] = courseArray.filter(el => el.enabled);
        let temp: any
        temp = courseArray.filter(el => el.id === props.traineeData.currentCourseId).length ? courseArray.filter(el => el.id === props.traineeData.currentCourseId)[0] : {
            enabled: 0,
            id: 0,
            title: '',
            total_backing_events: 0,
            total_days: 0
        }
        setCourse(temp)
        setCourses(tempArray);
        setSelectedCourseId(temp.id)
    }

    const setCourseById = (id: number) => {
        let temp: Course
        temp = courses.filter(el => el.id === id)[0]
        setCourse(temp)
    }

    const getPrompt = (currentCourseId: number, currentCourseDay: number) => {
        if (currentCourseId === 0) {
            setActivity("No course assigned for this trainee");
            setSafety("No course assigned for this trainee");
            setHasRoadTest(false);
            return;
        }

        ApiService.getTrainingPrompts('dailyReport', {currentCourseId, currentCourseDay}).then(it => {
            setActivity(it.activity);
            setSafety(it.safety);
            setHasRoadTest(it.roadTest === 1);
        });
    }

    const submitCourseChange = () => {
        ApiService.assignTraineeCourse('dailyReport', {traineeCode: props.traineeData.traineeCode, courseId: selectedCourseId}).then(() => {
            setChangingCourse(false);
            setCourseById(selectedCourseId);
        });
    }

    const resetScores = () => {
        setBackingScore(0);
        setTurningScore(0);
        setRoadHabitsScore(0);
        setHOSScore(0);
        setTabletScore(0);
        setCityScore(0);
        setHighwayScore(0);
        setDefensiveScore(0);
    }
    const resetForm = () => {
        setShowRoadTest(false);
    }

    const backingCriteria = [
        '1. Trainee is unable to complete the movement successfully. Cannot perform a 45, 90, or straight back without step-by-step instruction from the trainer.',
        '2. Trainee can perform a backing event; however, not in a timely manner. Takes the trainee more than 10 minutes with multiple pull ups. Trainee does not do one or any of the following: GOAL (Get Out and Look), use mirrors, honk horn before backing.',
        '3. Trainee can perform a backing event in under 10 minutes with multiple pull ups. Trainee does not do one of the following: GOAL (Get Out and Look), use mirrors, honk horn before backing.',
        '4. Trainee can perform a backing event in under 7 minutes with 5 or less pull ups. Trainee does all of the following: GOAL (Get Out and Look), use mirrors, honk horn before backing.',
        '5. Trainee can perform a backing event in under 5 minutes with 3 or less pull ups. Trainee does all of the following: GOAL (Get Out and Look), use mirrors, honk horn before backing.'
    ]
    const turningCriteria = [
        '1.	Trainee is unable to negotiate a turn without step-by-step instruction from the trainer. Trainee may have a close call during a turning event where tires come up on the curb or into the shoulder of the road. Trainee does not set up the turn properly or use mirrors to clear the trailer tires.',
        '2.	Trainee can negotiate a turn, however; does not set up properly and may be curbing their tires. Also not turning into the proper lane at an intersection.',
        '3.	Trainee can negotiate a turn, however; one of the following is an issue: does not set up properly, curbs tire or runs onto sidewalk, or is turning into an incorrect lane at an intersection.',
        '4.	Trainee can negotiate a turn. Can set up properly, uses mirrors to clear trailer tires, and is turning into the proper lane; however, may have occasional issues when performing multiple turns in a day.',
        '5.	Trainee can successfully negotiate a turn consistently. Has a proper set up, uses mirrors to clear trailer tires, and turns into the proper lane. Consistent performance throughout the day.'
    ]
    const habitsCriteria = [
        '1.	Trainee does not adjust driving habits for road or weather conditions. Driving too fast for conditions, does not control speed downhill or around ramps or curves, and is not adjusting to traffic conditions.',
        '2.	Trainee is not consistent in adjusting driving habits for changing conditions throughout the day. May adjust occasionally, but not for all necessary changes is conditions.',
        '3.	Trainee recognizes conditions where driving habits need to be adjusted but does not fully adjust driving habits. Example: trainee slows down but does not also increase following distance in inclement weather.',
        '4.	Trainee recognizes and adjusts driving habits for conditions, however; may need to improve in one of the following areas (ramps and curves, controlling speed downhill, weather conditions, traffic conditions).',
        '5.	Trainee always adjusts driving habits according to conditions. Trainee effectively recognizes and changes driving behavior for changes in the following ramps and curves, downhill, weather conditions, and traffic conditions.</span>'
    ]
    const cityCriteria = [
        '1.	Trainee does not negotiate turns, intersections, does not signal, or use their mirrors to negotiate traffic. Trainee may have a near miss while in a city or industrial area.',
        '2.	Trainee can drive in cities and industrial areas; however, does not negotiate intersections or turns properly, does not signal, and only occasionally uses their mirrors in changing lanes. Trainee may be waiting until the last chance to change lanes for an exit or get into the proper lane for an intersection.',
        '3.	Trainee can drive in cities and industrial areas; however, needs to improve on more than one of the following areas: negotiating intersections and turns, signaling appropriately, or using their mirrors when changing lanes or negotiating turns.',
        '4.	Trainee can drive in cities and industrial areas proficiently; however, needs to improve on one of the following areas: negotiating intersections and turns, signaling appropriately, or using their mirrors when changing lanes or negotiating turns.',
        '5.	Trainee proficiently negotiates city and industrial areas. Trainee negotiates intersections and turns properly, signals in advance of movement, and always uses their mirrors when changing lanes or negotiating turns.</span>'
    ]
    const highwayCriteria = [
        '1.	Trainee does not maintain their lane, is in a restricted lane, and does not control their speed or adjust speed for construction zones and changing speed zones. Any time the trainee stops on the side of the road for something other than an emergency it is an automatic 1 in this section.',
        '2.	Trainee can drive on the highway, however; is not proficient in more than one of the following areas: maintaining lane control, using the appropriate lane, maintaining an appropriate speed, or adjusting speed for construction zones or changing speed limits.',
        '3.	Trainee can drive on the highway; however, is not proficient in only one of the following areas: maintaining lane control, using the appropriate lane, maintaining an appropriate speed, or adjusting speed for construction zones or changing speed limits.',
        '4.	Trainee can drive on the highway, however; may have an occasional critical event or one event throughout the day of the following: maintaining lane control, using the appropriate lane, maintaining an appropriate speed, or adjusting speed for construction zones or changing speed limits.',
        '5.	Trainee shows proficiency in all areas of highway driving. Trainee maintains lane control and is always in the appropriate lane, always maintains an appropriate speed on the highway, and adjusts their speed appropriately for construction zones and changes in the speed limit.'
    ]
    const tabletCriteria = [
        '1.	Trainee does not understand how to use the tablet and requires direct supervision on all tasks using the tablet.',
        '2.	Trainee can use the tablet but does require assistance regularly. Trainee is not proficient in more than one of the following areas: GPS / Navigation, Workflow, messages (including loaded or empty), DVIR or Pretrip Inspection submissions, and the HOS App.',
        '3.	Trainee can use the tablet but requires assistance occasionally. Trainee is not proficient in only one of the following areas: GPS / Navigation, Workflow, messages (including loaded or empty), DVIR or Pretrip Inspection submissions, and the HOS App.',
        '4.	Trainee can use the tablet but may still require assistance. Trainee shows proficiency in each of the following apps: GPS / Navigation, Workflow, messages (including loaded or empty), DVIR or Pretrip Inspection submissions, and the HOS App.',
        '5.	Trainee shows proficiency in using the tablet. The trainee requires no assistance and is proficient in all the following apps: GPS / Navigation, Workflow, messages (including loaded or empty), DVIR or Pretrip Inspection submissions, and the HOS App.'
    ]
    const hosCriteria = [
        '1.	Trainee does not understand hours of service or trip planning. Is unable to plan out their day or utilize their available time.',
        '2.	Trainee needs assistance regularly in understanding available time. Has a general understanding of the hours of service but still does not fully understand the regulation. Trainee cannot plan out their day according to available hours.',
        '3.	Trainee understands available hours and hours of service regulations. Trainee does need assistance in trip planning to understand how to utilize available hours and take breaks on time.',
        '4.	Trainee understands hours of service and available time. Trainee can plan their trip, but may need assistance routing.',
        '5.	Trainee shows proficiency in understanding the hours of service regulations and effectively plans their trip for their available time. Trip plan includes the following areas: routing, scaling their load, potential weigh stations, break locations with back up locations, and on time ETA for delivery.'
    ]
    const defenseCriteria = [
        '1.  Trainee does not understand defensive driving principles and does not practice the 5 Key Points of Safe Driving.',
        '2.	Trainee requires monitoring and does not do more than one of the following: aim high in steering, get the big picture, keep your eyes moving, leave yourself an out, and make sure they see you. ',
        '3.	Trainee understands the 5 Key Points of Safe Driving; however, needs improvement in one of the following areas: aim high in steering, get the big picture, keep your eyes moving, leave yourself an out, and make sure they see you.',
        '4.	Trainee understands and practices the 5 Key Points of Safe Driving. Trainee may still have one critical event or rare event in the day regarding Defensive Driving practices.',
        '5.	Trainee shows proficiency in Defensive Driving. Understands the 5 Key Points of Safe Driving, and is consistently practicing these key points.'
    ]

    return (
        <div style={{overflow: "auto", backgroundColor: "#f4f5f8"}}>

            <IonItem lines="none" color="light">
                <div className="item-container" style={{backgroundColor: "#ffffff", borderRadius: "10px", padding: "8px"}}>
                    <p className="subtitle" style={{margin: 0, padding: 0}}>Course Info</p>
                    {course!.id !== 0 ? <>
                            <p style={{fontSize: "large", margin: 0}}>{course!.title}</p>
                            <p style={{margin: 0}}>Backing Events {course!.total_backing_events}</p>
                            <p style={{margin: 0, display: "flex", alignItems: "center", gap: "4px"}}><IonIcon icon={calendarClearOutline}></IonIcon>{course!.total_days} days</p> </>
                        :
                        <p style={{fontSize: "large", margin: 0}}>No Course Assigned</p>
                    }
                    <p style={{color: "#D0A024", fontSize: "12px"}} onClick={() => setChangingCourse(true)}>Assign new course</p>
                    {changingCourse ?
                        <div className="item-container">
                            <div className="input-container">
                                <select id="state" className="input" placeholder=" " value={selectedCourseId} onChange={e => setSelectedCourseId(parseInt(e.target.value!))} style={{height: "20px"}}>
                                    {courses.map(function (element) {
                                        return <option value={element.id}>{element.title}</option>
                                    })}
                                </select>
                                <p className="placeholder"></p>
                            </div>
                            <div className="space-between">
                                <p onClick={() => {
                                    submitCourseChange()
                                }} style={{color: "#5096FF"}}>Save</p>
                                <p style={{color: "#212121"}} onClick={() => {
                                    setChangingCourse(false)
                                }}>Cancel</p>
                            </div>
                        </div> : null}
                </div>
            </IonItem>
            <div className="divider-divider"></div>
            <IonItem color="light" lines="none">
                <div className="item-container" style={{backgroundColor: "#ffffff", borderRadius: "10px", padding: "8px"}}>
                    <div style={{"margin": "8px"}}>
                        <p className="title">Activity Prompt</p>
                        <p className="subtitle">{activity}</p>
                    </div>
                    <div style={{"margin": "8px"}}>
                        <p className="title">Safety Prompt</p>
                        <p className="subtitle">{safety}</p>
                    </div>
                </div>
            </IonItem>
            <div className="divider-divider"></div>
            <IonItem lines="none" color="light">
                <div className="item-container" style={{backgroundColor: "#ffffff", borderRadius: "10px", padding: "8px"}}>
                    <p className="title" style={{padding: "8px", textAlign: "center"}}>{hasRoadTest ? <span style={{color: '#6e9c00'}}>Recommended for: <br/>{trainingDate}</span> :
                        <span style={{color: '#cf3c4f'}}>No road test required for: <br/>{trainingDate}</span>}</p>
                    <p className="subtitle" style={{padding: "0px 8px 12px 8px", textAlign: "center"}}>{!hasRoadTest ? "Still need to complete a road test?" : ""}</p>
                    <button className="western-button submit" disabled={props.traineeData.currentCourseId === 0} onClick={() => {
                        setShowRoadTest(true)
                    }}>ROAD TEST FORM
                    </button>

                </div>
            </IonItem>
            {showRoadTest ? <RoadTest traineeCode={props.traineeData.traineeCode} trainerCode={props.traineeData.trainerCode} hideTest={resetForm}/> : null}

            <IonItem lines="none" color="light">
                <div className="item-container">
                    <p>Training Date: {trainingDate}</p>
                    <p style={reportTimer === 'Not Ready' || props.traineeData.currentCourseId === 0 ? {color: '#cf3c4f'} : {color: '#6e9c00'}}>{reportTimer}</p>
                </div>
            </IonItem>
            <div className="divider-divider"></div>

            <IonItem lines="none" color="light">
                <div className="item-container" style={{display: "flex"}}>
                    <p style={{color: "#FF0000", width: "60%", padding: '5px', alignItems: "center"}}>Was the trainee involved <br/>in an accident? <IonIcon icon={alertCircleOutline}
                                                                                                                                                             style={{fontSize: "medium"}}></IonIcon></p>
                    <div className="input-container" style={{width: "25%", marginLeft: '15px'}}>
                        <select id="accident" className="input" placeholder=" " value={traineeAccident} onChange={e => {
                            setTraineeAccident(e.target.value!);
                            traineeAccident === 'yes' ? resetScores() : console.log('no change');
                        }} style={{height: "20px", textAlign: "center"}}>
                            <option value={"no"}>No</option>
                            <option value={"yes"}>Yes</option>
                        </select>
                        <p className="placeholder"></p>
                    </div>
                </div>
            </IonItem>
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <p style={{color: "#D0A024", display: "flex", alignItems: "center"}}>Please select from criteria and to assign score. 1-5 <IonIcon icon={informationCircleOutline}
                                                                                                                                                       style={{fontSize: "medium"}}></IonIcon></p>

                </div>
            </IonItem>

            <IonItem lines="none" color="light">
                <div className="item-container">
                    <button disabled={traineeAccident === 'yes'} className="button" onClick={() => setShowBacking(!showBacking)}
                            style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "#ffffff", padding: "8px", borderRadius: "10px"}}>
                        <div style={{display: "flex"}}><p style={{color: "#212121"}}>Backing</p>
                            <p style={{color: backingScore ? "#71FE83" : "#cf3c4f", marginLeft: "8px"}}>{backingScore ? 'Complete ' : ''}</p></div>
                        {backingScore ? <p className="subtitle">{backingScore}/5</p> : null}
                        <IonIcon style={{color: "#212121", marginRight: "8px"}} icon={showBacking ? chevronDown : chevronUp}></IonIcon></button>
                </div>
            </IonItem>
            {showBacking ? <div className={showBacking ? "item-container openAnimation" : "item-container"} style={{position: "relative", backgroundColor: "#f4f5f8"}}>
                <strong style={{color: "#212121", padding: "0 8px"}}>Score: {backingScore}</strong>
                <p className="subtitle" style={{display: "flex", alignItems: "center", gap: "4px"}} onClick={() => setShowBackingCriteria(!showBackingCriteria)}>Rating Criteria <IonIcon
                    icon={informationCircleOutline}></IonIcon></p>
                {showBackingCriteria ? <div className="info-blurb">
                    <p className="subtitle">GOAL: Get Out And Look<br/>Blows horn before starting the back<br/>Mirror Use<br/>45, 90 and Straight Back</p>
                </div> : null}
                {backingCriteria.map((criteria, index) => {
                    return (
                        <IonItem lines="none" color="light" onClick={() => {
                            setShowBacking(false);
                            setBackingScore(index + 1)
                        }} key={index}>
                            <div className="item-container" style={{border: backingScore === index + 1 ? "2px solid #5096FF" : "2px solid #e6e6e6", borderRadius: "10px"}}>
                                <p className="subtitle" style={{color: backingScore === index + 1 ? "#5096FF" : "#666667"}}>{criteria}</p>
                            </div>
                        </IonItem>)
                })}
            </div> : null}
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <button disabled={traineeAccident === 'yes'} className="button" onClick={() => setShowTurning(!showTurning)}
                            style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "#ffffff", padding: "8px", borderRadius: "10px"}}>
                        <div style={{display: "flex"}}><p style={{color: "#212121"}}>Turning</p>
                            <p style={{color: turningScore ? "#71FE83" : "#cf3c4f", marginLeft: "8px"}}>{turningScore ? 'Complete' : ''}</p></div>
                        {turningScore ? <p className="subtitle">{turningScore}/5</p> : null}
                        <IonIcon style={{color: "#212121", marginRight: "8px"}} icon={showTurning ? chevronDown : chevronUp}></IonIcon></button>
                </div>
            </IonItem>
            {showTurning ? <div className={showTurning ? "item-container openAnimation" : "item-container"} style={{position: "relative", backgroundColor: "#f4f5f8"}}>
                <strong style={{color: "#212121", padding: "0 8px"}}>Score: {turningScore}</strong>
                <p className="subtitle" style={{display: "flex", alignItems: "center", gap: "4px"}} onClick={() => setShowTurningCriteria(!showTurningCriteria)}>Rating Criteria <IonIcon
                    icon={informationCircleOutline}></IonIcon></p>
                {showTurningCriteria ? <div className="info-blurb">
                    <p className="subtitle">Set up and execution of a turn<br/>Uses mirrors to clear trailer tires</p>
                </div> : null}
                {turningCriteria.map((criteria, index) => {
                    return (
                        <IonItem lines="none" color="light" onClick={() => {
                            setShowTurning(false);
                            setTurningScore(index + 1)
                        }} key={index}>
                            <div className="item-container" style={{border: turningScore === index + 1 ? "2px solid #5096FF" : "2px solid #e6e6e6", borderRadius: "10px"}}>
                                <p className="subtitle" style={{color: turningScore === index + 1 ? "#5096FF" : "#666667"}}>{criteria}</p>
                            </div>
                        </IonItem>)
                })}
            </div> : null}
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <button disabled={traineeAccident === 'yes'} className="button" onClick={() => setShowHabits(!showHabits)}
                            style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "#ffffff", padding: "8px", borderRadius: "10px"}}>
                        <div style={{display: "flex"}}><p style={{color: "#212121"}}>Driving Habits</p>
                            <p style={{color: roadHabitsScore ? "#71FE83" : "#cf3c4f", marginLeft: "8px"}}>{roadHabitsScore ? 'Complete' : ''}</p></div>
                        {roadHabitsScore ? <p className="subtitle">{roadHabitsScore}/5</p> : null}
                        <IonIcon style={{color: "#212121", marginRight: "8px"}} icon={showHabits ? chevronDown : chevronUp}></IonIcon></button>
                </div>
            </IonItem>
            {showHabits ? <div className={showHabits ? "item-container openAnimation" : "item-container"} style={{position: "relative", backgroundColor: "#f4f5f8"}}>
                <strong style={{color: "#212121", padding: "0 8px"}}>Score: {roadHabitsScore}</strong>
                <p className="subtitle" style={{display: "flex", alignItems: "center", gap: "4px"}} onClick={() => setShowHabitsCriteria(!showHabitsCriteria)}>Rating Criteria <IonIcon
                    icon={informationCircleOutline}></IonIcon></p>
                {showHabitsCriteria ? <div className="info-blurb">
                    <p className="subtitle">Ramps and Curves<br/>Downhill<br/>Weather Conditions<br/>Traffic Conditions</p>
                </div> : null}
                {habitsCriteria.map((criteria, index) => {
                    return (
                        <IonItem lines="none" color="light" onClick={() => {
                            setShowHabits(false);
                            setRoadHabitsScore(index + 1)
                        }} key={index}>
                            <div className="item-container" style={{border: roadHabitsScore === index + 1 ? "2px solid #5096FF" : "2px solid #e6e6e6", borderRadius: "10px"}}>
                                <p className="subtitle" style={{color: roadHabitsScore === index + 1 ? "#5096FF" : "#666667"}}>{criteria}</p>
                            </div>
                        </IonItem>)
                })}
            </div> : null}
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <button disabled={traineeAccident === 'yes'} className="button" onClick={() => setShowCity(!showCity)}
                            style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "#ffffff", padding: "8px", borderRadius: "10px"}}>
                        <div style={{display: "flex"}}><p style={{color: "#212121"}}>City Driving</p>
                            <p style={{color: cityScore ? "#71FE83" : "#cf3c4f", marginLeft: "8px"}}>{cityScore ? 'Complete' : ''}</p></div>
                        {cityScore ? <p className="subtitle">{cityScore}/5</p> : null}
                        <IonIcon style={{color: "#212121", marginRight: "8px"}} icon={showCity ? chevronDown : chevronUp}></IonIcon></button>
                </div>
            </IonItem>
            {showCity ? <div className={showCity ? "item-container openAnimation" : "item-container"} style={{position: "relative", backgroundColor: "#f4f5f8"}}>
                <strong style={{color: "#212121", padding: "0 8px"}}>Score: {cityScore}</strong>
                <p className="subtitle" style={{display: "flex", alignItems: "center", gap: "4px"}} onClick={() => setShowCityCriteria(!showCityCriteria)}>Rating Criteria <IonIcon
                    icon={informationCircleOutline}></IonIcon></p>
                {showCityCriteria ? <div className="info-blurb">
                    <p className="subtitle">Turns<br/>Signaling<br/>Mirror Use</p>
                </div> : null}
                {cityCriteria.map((criteria, index) => {
                    return (
                        <IonItem lines="none" color="light" onClick={() => {
                            setShowCity(false);
                            setCityScore(index + 1)
                        }} key={index}>
                            <div className="item-container" style={{border: cityScore === index + 1 ? "2px solid #5096FF" : "2px solid #e6e6e6", borderRadius: "10px"}}>
                                <p className="subtitle" style={{color: cityScore === index + 1 ? "#5096FF" : "#666667"}}>{criteria}</p>
                            </div>
                        </IonItem>)
                })}
            </div> : null}
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <button disabled={traineeAccident === 'yes'} className="button" onClick={() => setShowHighway(!showHighway)}
                            style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "#ffffff", padding: "8px", borderRadius: "10px"}}>
                        <div style={{display: "flex"}}><p style={{color: "#212121"}}>Highway Driving</p>
                            <p style={{color: highwayScore ? "#71FE83" : "#cf3c4f", marginLeft: "8px"}}>{highwayScore ? 'Complete' : ''}</p></div>
                        {highwayScore ? <p className="subtitle">{highwayScore}/5</p> : null}
                        <IonIcon style={{color: "#212121", marginRight: "8px"}} icon={showHighway ? chevronDown : chevronUp}></IonIcon></button>
                </div>
            </IonItem>
            {showHighway ? <div className={showHighway ? "item-container openAnimation" : "item-container"} style={{position: "relative", backgroundColor: "#f4f5f8"}}>
                <strong style={{color: "#212121", padding: "0 8px"}}>Score: {highwayScore}</strong>
                <p className="subtitle" style={{display: "flex", alignItems: "center", gap: "4px"}} onClick={() => setShowHighwayCriteria(!showHighwayCriteria)}>Rating Criteria <IonIcon
                    icon={informationCircleOutline}></IonIcon></p>
                {showHighwayCriteria ? <div className="info-blurb">
                    <p className="subtitle">Lane Control and Lane usage<br/>Appropriate Speed Control<br/>Sitting Duck:<br/>Never stop on the side of the road unless you have experienced a true
                        emergency</p>
                </div> : null}
                {highwayCriteria.map((criteria, index) => {
                    return (
                        <IonItem lines="none" color="light" onClick={() => {
                            setShowHighway(false);
                            setHighwayScore(index + 1)
                        }} key={index}>
                            <div className="item-container" style={{border: highwayScore === index + 1 ? "2px solid #5096FF" : "2px solid #e6e6e6", borderRadius: "10px"}}>
                                <p className="subtitle" style={{color: highwayScore === index + 1 ? "#5096FF" : "#666667"}}>{criteria}</p>
                            </div>
                        </IonItem>)
                })}
            </div> : null}
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <button disabled={traineeAccident === 'yes'} className="button" onClick={() => setShowTablet(!showTablet)}
                            style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "#ffffff", padding: "8px", borderRadius: "10px"}}>
                        <div style={{display: "flex"}}><p style={{color: "#212121"}}>Tablet</p>
                            <p style={{color: tabletScore ? "#71FE83" : "#cf3c4f", marginLeft: "8px"}}>{tabletScore ? 'Complete' : ''}</p></div>
                        {tabletScore ? <p className="subtitle">{tabletScore}/5</p> : null}
                        <IonIcon style={{color: "#212121", marginRight: "8px"}} icon={showTablet ? chevronDown : chevronUp}></IonIcon></button>
                </div>
            </IonItem>
            {showTablet ? <div className={showTablet ? "item-container openAnimation" : "item-container"} style={{position: "relative", backgroundColor: "#f4f5f8"}}>
                <strong style={{color: "#212121", padding: "0 8px"}}>Score: {tabletScore}</strong>
                <p className="subtitle" style={{display: "flex", alignItems: "center", gap: "4px"}} onClick={() => setShowTabletCriteria(!showTabletCriteria)}>Rating Criteria <IonIcon
                    icon={informationCircleOutline}></IonIcon></p>
                {showTabletCriteria ? <div className="info-blurb">
                    <p className="subtitle">GPS<br/>Workflow<br/>Loaded, Empty, Messaging<br/>DVIR / Pretrip<br/>HOS App</p>
                </div> : null}
                {tabletCriteria.map((criteria, index) => {
                    return (
                        <IonItem lines="none" color="light" onClick={() => {
                            setShowTablet(false);
                            setTabletScore(index + 1)
                        }} key={index}>
                            <div className="item-container" style={{border: tabletScore === index + 1 ? "2px solid #5096FF" : "2px solid #e6e6e6", borderRadius: "10px"}}>
                                <p className="subtitle" style={{color: tabletScore === index + 1 ? "#5096FF" : "#666667"}}>{criteria}</p>
                            </div>
                        </IonItem>)
                })}
            </div> : null}
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <button disabled={traineeAccident === 'yes'} className="button" onClick={() => setShowHOS(!showHOS)}
                            style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "#ffffff", padding: "8px", borderRadius: "10px"}}>
                        <div style={{display: "flex"}}><p style={{color: "#212121"}}>Service Hours</p>
                            <p style={{color: hosScore ? "#71FE83" : "#cf3c4f", marginLeft: "8px"}}>{hosScore ? 'Complete' : ''}</p></div>
                        {hosScore ? <p className="subtitle">{hosScore}/5</p> : null}
                        <IonIcon style={{color: "#212121", marginRight: "8px"}} icon={showHOS ? chevronDown : chevronUp}></IonIcon></button>
                </div>
            </IonItem>
            {showHOS ? <div className={showHOS ? "item-container openAnimation" : "item-container"} style={{position: "relative", backgroundColor: "#f4f5f8"}}>
                <strong style={{color: "#212121", padding: "0 8px"}}>Score: {hosScore}</strong>
                <p className="subtitle" style={{display: "flex", alignItems: "center", gap: "4px"}} onClick={() => setShowHOSCriteria(!showHOSCriteria)}>Rating Criteria <IonIcon
                    icon={informationCircleOutline}></IonIcon></p>
                {showHOSCriteria ? <div className="info-blurb">
                    <p className="subtitle">Understands trip planning and HOS Rules and Regulations</p>
                </div> : null}
                {hosCriteria.map((criteria, index) => {
                    return (
                        <IonItem lines="none" color="light" onClick={() => {
                            setShowHOS(false);
                            setHOSScore(index + 1)
                        }} key={index}>
                            <div className="item-container" style={{border: hosScore === index + 1 ? "2px solid #5096FF" : "2px solid #e6e6e6", borderRadius: "10px"}}>
                                <p className="subtitle" style={{color: hosScore === index + 1 ? "#5096FF" : "#666667"}}>{criteria}</p>
                            </div>
                        </IonItem>)
                })}
            </div> : null}
            <IonItem lines="none" color="light">
                <div className="item-container">
                    <button disabled={traineeAccident === 'yes'} className="button" onClick={() => setShowDefense(!showDefense)}
                            style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", backgroundColor: "#ffffff", padding: "8px", borderRadius: "10px"}}>
                        <div style={{display: "flex"}}><p style={{color: "#212121"}}>Defensive Driving</p>
                            <p style={{color: defensiveScore ? "#71FE83" : "#cf3c4f", marginLeft: "8px"}}>{defensiveScore ? 'Complete' : ''}</p></div>
                        {defensiveScore ? <p className="subtitle">{defensiveScore}/5</p> : null}
                        <IonIcon style={{color: "#212121", marginRight: "8px"}} icon={showDefense ? chevronDown : chevronUp}></IonIcon></button>
                </div>
            </IonItem>
            {showDefense ? <div className={showDefense ? "item-container openAnimation" : "item-container"} style={{position: "relative", backgroundColor: "#f4f5f8"}}>
                <strong style={{color: "#212121", padding: "0 8px"}}>Score: {defensiveScore}</strong>
                <p className="subtitle" style={{display: "flex", alignItems: "center", gap: "4px"}} onClick={() => setShowDefenseCriteria(!showDefenseCriteria)}>Rating Criteria <IonIcon
                    icon={informationCircleOutline}></IonIcon></p>
                {showDefenseCriteria ? <div className="info-blurb">
                    <p className="subtitle">Aim high in steering<br/>Get the big picture<br/>Keep your eyes moving<br/>Leave yourself an out<br/>Make sure they see you</p>
                </div> : null}
                {defenseCriteria.map((criteria, index) => {
                    return (
                        <IonItem lines="none" color="light" onClick={() => {
                            setShowDefense(false);
                            setDefensiveScore(index + 1)
                        }} key={index}>
                            <div className="item-container" style={{border: defensiveScore === index + 1 ? "2px solid #5096FF" : "2px solid #e6e6e6", borderRadius: "10px"}}>
                                <p className="subtitle" style={{color: defensiveScore === index + 1 ? "#5096FF" : "#666667"}}>{criteria}</p>
                            </div>
                        </IonItem>)
                })}
            </div> : null}
            <IonItem lines="none" color="light">
                <div className="item-container" style={{textAlign: "center"}}>
                    <h2 className="title">Total Score: {backingScore + turningScore + tabletScore + roadHabitsScore + hosScore + highwayScore + cityScore + defensiveScore}/40</h2>
                </div>
            </IonItem>
            <IonItem lines="none" color="light">
                <div className="item-container" style={{display: "flex"}}>
                    <p style={{width: "50%", marginLeft: "15px", padding: '15px', alignItems: "center"}}>Ready for Solo?</p>
                    <div className="input-container" style={{width: "30%"}}>
                        <select id="solo" className="input" disabled={traineeAccident === 'yes'} placeholder=" " value={traineeReady} onChange={e => {
                            setTraineeReady(e.target.value!);
                            traineeAccident === 'yes' ? resetScores() : console.log('no change');
                        }} style={{height: "20px", textAlign: "center"}}>
                            <option value={"yes"}>Yes</option>
                            <option value={"no"}>No</option>
                        </select>
                        <p className="placeholder"></p>
                    </div>
                </div>
            </IonItem>
            <div className="divider-divider"></div>
            <div style={{margin: "30px"}}>
                <button className="western-button submit" disabled={reportTimer === 'Not Ready'}>SUBMIT REPORT</button>
            </div>

        </div>
    )
}

export default DailyReport
